// utils/groupResults.js
export const groupResults = (data) => {
  const grouped = data.reduce((acc, item) => {
    const groupName = item.Grupo;
    if (!acc[groupName]) acc[groupName] = [];
    acc[groupName].push(item);
    return acc;
  }, {});

  Object.keys(grouped).forEach((group) => {
    grouped[group].sort((a, b) => {
      const timeA = new Date(`1970-01-01T${a.HoraProgramado || "00:00"}:00Z`).getTime();
      const timeB = new Date(`1970-01-01T${b.HoraProgramado || "00:00"}:00Z`).getTime();
      return timeA - timeB;
    });
  });

  return Object.values(grouped).flat();
};
